import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#090A0F] px-6">
      <div className="text-center fade-up" data-testid="payment-cancel">
        <XCircle className="w-16 h-16 text-slate-500 mx-auto mb-6" />
        <h1 className="font-display text-4xl text-white mb-2">Checkout cancelled</h1>
        <p className="text-slate-400 mb-8">No charge was made. You can pick up where you left off.</p>
        <Button onClick={() => navigate(-1)} className="bg-[#D4AF37] text-black hover:bg-[#E2C044] rounded-full">
          Back to order
        </Button>
      </div>
    </div>
  );
}
